import type { OpenAPIV3_1 as OpenAPIV31 } from 'openapi-types';

import type { OasDocumentObject3XExtension } from './OasDocumentObjectExtension';
import type { OasOperationObjectExtension } from './OasOperationObjectExtension';

export type OasDocument3XExtended =
  OpenAPIV31.Document<OasOperationObjectExtension> &
    OasDocumentObject3XExtension;
export type OasOperationObject3XExtended = OpenAPIV31.OperationObject &
  OasOperationObjectExtension;
export type OasPathsObject3XExtended =
  OpenAPIV31.PathsObject<OasOperationObjectExtension>;
export type OasPathItemObject31Extended =
  OpenAPIV31.PathItemObject<OasOperationObjectExtension>;
